import { Middleware } from '@reduxjs/toolkit';
import { setApiState } from '../slices/apiStateSlice';
import { parsePartialSuccess } from '../utils/partialSuccessHandling';

const partialSuccessMiddleware: Middleware =
  (store) => (next: any) => (action: any) => {
    const isFulfilled = action?.meta?.requestStatus === 'fulfilled';

    if (isFulfilled) {
      if (action?.payload?.code === 'PartialSuccess') {
        const newAction = {
          ...action,
          payload: {
            ...action?.payload,
            code: 'PartialSuccess',
          },
        };

        // Parse the MFA response
        const partialSuccessHandler = parsePartialSuccess(newAction);

        if (partialSuccessHandler) {
          store.dispatch(
            setApiState({
              status: partialSuccessHandler.status,
              code: partialSuccessHandler.code,
              action: partialSuccessHandler.action,
              actionType: partialSuccessHandler.actionType,
              message: partialSuccessHandler.message,
              detail: partialSuccessHandler.detail,
              showDetails: partialSuccessHandler.showDetails,
            }),
          );
        }
      }
    }

    return next(action);
  };

export default partialSuccessMiddleware;
